import { CommonFilterList, FilterConfig } from 'common/models/filter.model';
import { GLOBAL_FILTERS } from './constants';
import { FILTER_ITEMS } from './constants-filter-configs';

// Remove Product from the Universal Filters List
const filteredGlobalFilters = GLOBAL_FILTERS.filter((filter: FilterConfig) => {
  return (filter.property as CommonFilterList) !== CommonFilterList.Product;
});

export const UNIVERSAL_FILTER: FilterConfig[] = [FILTER_ITEMS.dateRange, ...filteredGlobalFilters];
